import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import EmployeeForm from "../../../components/FormEmployee";
import Header from "../../../components/Header";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

const UpdateEmployee = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [open, setOpen] = useState(false);
  const isRTL = i18n.language === "ar";
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const response = await axios.get(`${apiUrl}/employees/${id}`);
        setEmployee(response.data);
      } catch (error) {
        console.error(t("error_fetching"), error);
      }
    };
    fetchEmployee();
  }, [id, t]);

  const handleFormSubmit = async (values) => {
    try {
      const payload = {
        role: values.role,
        name: values.name,
        phone: values.phone,
        ...(values.role === "employee" && {
          salary: Number(values.salary),
          hire_date: values.hire_date,
          city: values.city,
        }),
        ...(values.role === "supplier" && { companyName: values.companyName }),
        ...(values.role === "customer" && { customerCode: values.customerCode }),
      };

      await axios.patch(`${apiUrl}/employees/${id}`, payload);
      setOpen(true);
      setTimeout(() => {
        navigate("/employee");
      }, 1000);
    } catch (error) {
      console.error(t("error_updating"), error.response?.data);
    }
  };

  if (!employee) {
    return <Box m="20px">{t("loading")}</Box>;
  }

  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Header title={t("update_employee")} subtitle={t("update_employee_subtitle")} />
      <EmployeeForm
        initialValues={{
          ...employee,
          hire_date: employee.hire_date
            ? new Date(employee.hire_date).toISOString().split("T")[0]
            : "",
        }}
        handleFormSubmit={handleFormSubmit}
        buttonLabel={t("update_button")}
      />
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{
            width: "100%",
            textAlign: isRTL ? "right" : "left",
            direction: isRTL ? "rtl" : "ltr",
            justifyContent: isRTL ? "flex-end" : "flex-start",
          }}
        >
          {t("success_message")}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateEmployee;